module.exports = __webpack_public_path__ + "static/media/logo.aa026e80.png";